/* Library */
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import commonUtil from '../../../../utils/commonUtil';
import { constEventStatus } from '../../../../utils/clientConstant';
import EventWizard from './../EventWizard';
import CalenderSample from '../../../../components/ZUILib/CalenderSample';
import TextInput from '../../../../components/ZUILib/TextInput';
import SelectionTab from '../../../../components/ZUILib/SelectionTab';
import FloatingLabelTextArea from '../../../../components/ZUILib/FloatingLabelTextArea';
import KalturaFileUpload from '../../../../components/KalturaFileUpload';
import GCPCloudImageUploader from '../../../../components/GCPCloudImageUploader/GCPCloudImageUploader';
import Warning from '../../../../components/Warning';
import Warning2 from '../../../../components/Warning2';
import ApplyCSS from '../../../../components/ApplyCSS';
import { constAPISuccess, constAPIFailure } from '../../../../utils/clientConstant';
import EventTemplate from '../../../../components/EventTemplate';

import * as CreateEventActions from './actions';
import * as createEventObject from '../../../createEvent/actions';
import { createTag, createTagsForInvalidFormControls } from '../../../../utils/googleTagManagerUtils';

const errorObject = require('../../../../utils/errors/LP_GR_error.json');


import ColorPickerOverlay from './components/colorPickerOverlay';
import ColorPicker from './components/colorPicker';

import ImageOptionsModal from '../../../eventManagement/page/GiftList/components/Personalization/components/ImageOptionsModal';
import CameraCaptureModal from '../../../eventManagement/page/GiftList/components/Personalization/components/CameraCaptureModal';

const pageName = 'createEvent';
const { defineCreateEventData } = createEventObject;
const channel = commonUtil.getChannel();
const { defineStoreListData, validateEventName, setSelectedImage1, setSelectedImage2, setEventTxtValue, setEventDateValue, setEventComment, setThemeData, setSelectedThemeUid } = CreateEventActions;

@connect(store => ({
  lables: store.labels.data,
  user: store.user.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  globleObj: store.globleObject,
  stateList: store.createEvent.dataState,
  storeList: store.createEvent.dataStore,
  createEventObject: store.createEventObject,
  eventcategory: store.eventcategory,
  isColorPickerOpen: store.createEvent.isColorPickerOpen
}),
  { ...CreateEventActions })

class CreateEvent extends Component {
  constructor(props) {
    super(props);
    this.calendar = {
      maxDays: '',
      minDays: '',
    };
    this.currentIndex = '';
    this.currentEvent = '';
    this.warningMessage = '';
    this.uploadedImage = '';
    this.uploadedImage2 = '';
    this.selectedThemeUid = '';
    this.ownerName = '';
    this.coOwnerName = '';
    this.celebrityName = '';
    this.formData = {
      createEvent: {
        state: '',
        store: '',
        eventName: '',
        eventDate: '',
        imageURL: '',
        imageURL2: '',
        templateId: '',
      },
    };
    this.onChangeEventName = this.onChangeEventName.bind(this);
    this.onChangeEventDate = this.onChangeEventDate.bind(this);
    this.onChangeEventComment = this.onChangeEventComment.bind(this);
    this.state = {
      isDisabled: true,
      showImageModal: false,
      showCameraModal: false,
      isImage1:true,
      txtEventComment: '',
      successUpdate: false,
      isUpdated: false,
      isCommentUpdated: false,
      image1Loading: false,
      image2Loading: false,
    }
    this.eventIcon = '';
    this.eventTheme = [];
    this.toggleMenu = this.toggleMenu.bind(this);
    this.menuRef = null;
    this.image1UploaderRef = React.createRef();
    this.image2UploaderRef = React.createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    
  }

  handleFileUploadClick = _.debounce(() => {
    const eventHasPhoto = !_.isEmpty(this.formData.createEvent.imageURL);
    if(!this.props.isGiftListCreateEvent){
    createTag({
      event: 'mesa_regalos',
      phase: 'Crear mesa de regalos',
      step: 'Datos del evento subir imagen',
      selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
      seccion: 'Mesa de Regalos',
      foto: eventHasPhoto ? 'Si' : 'No',
    });
    }
  }, 1000)

  handleFileUploadClick2 = _.debounce(() => {
    const eventHasPhoto2 = !_.isEmpty(this.formData.createEvent.imageURL2);
    if(!this.props.isGiftListCreateEvent){
    createTag({
      event: 'mesa_regalos',
      phase: 'Crear mesa de regalos',
      step: 'Datos del evento subir imagen',
      selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
      seccion: 'Mesa de Regalos',
      foto: eventHasPhoto2 ? 'Si' : 'No',
    });
    }
  }, 1000)

  componentDidMount() {
    if (this.formData && this.formData.createEvent && this.formData.createEvent.store) {
      const storDropDown = document.querySelector('#storeList');
      storDropDown.style.display = 'block';
    }

    if(!this.props.isGiftListCreateEvent){
      this.props.onReference(this);
      if (document) {
        document.querySelector('#createEvent').classList.add(this.props.animationClass);
      }
    } else {
      document.addEventListener('mousedown', this.handleOutsideClick);

      if (document.querySelector('.file-upload')) {
        document.querySelectorAll('.file-upload').forEach((el) => {
          el.style.display = 'none';
        });
      }

      const { eventDetailsInfo, setEventTxtValue, setEventDateValue, setSelectedImage1, setSelectedImage2, setEventComment, setSelectedThemeUid } = this.props;

      setEventTxtValue(eventDetailsInfo.eventName || "");
      setEventDateValue(eventDetailsInfo.eventDate || "")
      setSelectedImage1(eventDetailsInfo?.imageURL || "");
      setSelectedImage2(eventDetailsInfo?.eventBackground || "");
      setEventComment(eventDetailsInfo?.comment || "");
      setSelectedThemeUid(eventDetailsInfo?.eventTheme || "");

      this.currentEvent = this.props.eventType || this.currentEvent;
    }
    
    commonUtil.goToTop();

    if(!this.props.isGiftListCreateEvent){
    const fileUploadTargets = [document.querySelector('#gcpDropTarget > label'), document.querySelector('#croppieImg')];
    fileUploadTargets.forEach(target => target.addEventListener('click', this.handleFileUploadClick));

    const fileUploadTargets2 = [Array.from(document.querySelectorAll('#gcpDropTarget > label.file-upload'))
      .find(el => el.textContent.trim().startsWith('Sube una imagen de portada') || el.textContent.trim().startsWith('Upload a cover image')), document.querySelector('#croppieImg2')];
    fileUploadTargets2.forEach(target => target.addEventListener('click', this.handleFileUploadClick2));

    const { setEventDateValue, eventTxtValue } = this.props;

    if(eventTxtValue && setEventDateValue){
      this.setState({
        isDisabled: false,
      });
    } else {
      this.setState({
        isDisabled: true,
      });
    }
    }


    const eventList = this.props.eventcategory?.data?.eventConfigurations ?? [];
    const event = eventList.filter(obj => obj.name === this.currentEvent);

    if (
      event?.[0]?.event_themes &&
      event[0].event_themes.length > 0 ){
      if(event[0]?.event_themes[0]){
        event[0].event_themes[0].isDefault = true;
      }
      this.props.setThemeData(event[0].event_themes);
      this.eventTheme = event[0].event_themes;
    }
  }

  componentDidUpdate(prevProps) {
  //if (prevProps.selectedThemeUid !== this.props.selectedThemeUid) {
    if (this.formData?.createEvent) {
      this.formData.createEvent.templateId = this.props.selectedThemeUid;
    }
  //}
}


  componentWillUnmount() {
    if(!this.props.isGiftListCreateEvent){
    const fileUploadTargets = [document.querySelector('#gcpDropTarget > label'), document.querySelector('#croppieImg')];
    fileUploadTargets.forEach(target => target.removeEventListener('click', this.handleFileUploadClick));

    const fileUploadTargets2 = [Array.from(document.querySelectorAll('#gcpDropTarget > label.file-upload'))
      .find(el => el.textContent.trim().startsWith('Sube una imagen de portada') || el.textContent.trim().startsWith('Upload a cover image')), document.querySelector('#croppieImg2')];
    fileUploadTargets2.forEach(target => target.removeEventListener('click', this.handleFileUploadClick2));
    }

    if(this.props.isGiftListCreateEvent){
      document.removeEventListener('mousedown', this.handleOutsideClick);
      const {
        setEventTxtValue,
        setEventDateValue,
        setSelectedImage1,
        setSelectedImage2,
        setEventComment,
        setSelectedThemeUid,
        setThemeData,
      } = this.props;
    
      setEventTxtValue("");
      setEventDateValue("");
      setSelectedImage1("");
      setSelectedImage2("");
      setEventComment("");
      setSelectedThemeUid("");
      setThemeData([]);
    }

    if (document.body.classList.contains('body-no-scroll')) {
      document.body.classList.remove('body-no-scroll');
    }

  }

  onValueUpdate = (type, value) => {
    const {
      eventDetailsInfo,
      eventTxtValue,
      selectedImage1,
      selectedImage2,
      eventComment,
      selectedThemeUid,
    } = this.props;

    let isUpdated = false;
    let isCommentUpdated = false;

    let prevName = eventDetailsInfo?.eventName || "";
    let prevImage1 = eventDetailsInfo?.imageURL || "";
    let prevImage2 = eventDetailsInfo?.eventBackground || "";
    let prevComment = eventDetailsInfo?.comment || "";
    let prevEventTheme = eventDetailsInfo?.eventTheme || "";

    let name = eventTxtValue || "";
    let image1 = selectedImage1 || "";
    let image2 = selectedImage2 || "";
    let comment =  eventComment || "";
    let eventTheme = selectedThemeUid || "";

    if(type == 'name'){
      name = value
    }else if(type == 'image1'){
      image1 = value
    }else if(type == 'image2'){
      image2 = value
    }else if(type == 'comment'){
      comment = value
    }else if(type == 'eventTheme'){
      eventTheme = value
    }

    if (
      (name !== prevName) ||
      (image1 !== prevImage1) ||
      (image2 !== prevImage2) ||
      (eventTheme !== prevEventTheme)
    ) {
      isUpdated = true;
    }
    if(comment != prevComment){
      isCommentUpdated = true;
    }
      
      this.setState({
        isUpdated: isUpdated,
        isCommentUpdated: isCommentUpdated
      })
  }

  handleOutsideClick(event) {
    if (this.menuRef && !this.menuRef.contains(event.target)) {
      this.setState({ showImageModal: false });
    }
  }

  toggleMenu(event) {
    const name = event.target.getAttribute('name');
    this.setState({
      isImage1: (name == "Image 1")
    })
    this.setState(prevState => ({
      showImageModal: !prevState.showImageModal
    }));
  }

  static propTypes = {
    lables: PropTypes.object,
  };

  // openStoreDropdown = (e) => {
  //   const { defineStoreListData } = this.props; // eslint-disable-line no-shadow
  //   defineStoreListData(e.id);
  //   const storDropDown = document.querySelector('#storeList');
  //   storDropDown.style.display = 'block';
  // }

  onFileRemoved = () => {
  };
  onError = () => {
  };

  onFileSuccess = (data) => {
    this.warning.setMessage('');
    this.uploadedImage = data.dataUrl;
    document.querySelector('#croppieImg').src = data.dataUrl;
    const { setSelectedImage1 } = this.props;
    setSelectedImage1(data.dataUrl);
    this.onValueUpdate("image1",data.dataUrl);
    if(this.props.isGiftListCreateEvent){
      if(channel == 'wap'){
        document.querySelectorAll('.overlayDiv').forEach(el => {
          el.classList.add('overlayDivAdd');
        });
      }
      this.setState({ showImageModal: false });
    }
  }
  onFileSuccess2 = (data) => {
    this.warning.setMessage('');
    this.uploadedImage2 = data.dataUrl;
    document.querySelector('#croppieImg2').src = data.dataUrl;
    const { setSelectedImage2 } = this.props;
    setSelectedImage2(data.dataUrl);
    this.onValueUpdate("image2",data.dataUrl);
    if(this.props.isGiftListCreateEvent){
      if(channel == 'wap'){
        document.querySelectorAll('.overlayDiv').forEach(el => {
          el.classList.add('overlayDivAdd');
        });
      }
      this.setState({ showImageModal: false });
    }
  }
  onMaxFileSizeErrorCallback = () => {
    if(this.props.isGiftListCreateEvent){
      this.props.showMessagePopUp(false,false,false,'Tamaño de archivo entre 128 kb a 3 MB')
      this.setState({ showImageModal: false, successUpdate: false });
    } else {
      this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
    }
  }
  onMinFileSizeErrorCallback = () => {
    if(this.props.isGiftListCreateEvent){
      this.props.showMessagePopUp(false,false,false,'Tamaño de archivo entre 128 kb a 3 MB')
      this.setState({ showImageModal: false, successUpdate: false });
    } else {
      this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
    }
  }
  onFileAddedError = () => {
    if(this.props.isGiftListCreateEvent){
      this.props.showMessagePopUp(false,false,false,'Este archivo de extensión no está permitido.')
      this.setState({ showImageModal: false, successUpdate: false });
    } else {
      this.warning.setMessage('Este archivo de extensión no está permitido.');
    }
  }
  openProfileImageUploader = () => {
    document.querySelector('.file-upload').click();
  }
  openCamera = () => {
    this.setState({ showCameraModal: true, showImageModal: false });
  }
  onCameraCapture = (file) => {
    const uploader = this.state.isImage1 ? this.image1UploaderRef.current : this.image2UploaderRef.current;
    if (uploader && typeof uploader.handleFileSelect === 'function') {
      uploader.handleFileSelect(file);
    }
    this.setState({ showCameraModal: false });
  }
  openProfileImageUploader2 = () => {
    Array.from(document.querySelectorAll('#gcpDropTarget > label.file-upload'))
      .find(el => el.textContent.trim().startsWith('Sube una imagen de portada') || el.textContent.trim().startsWith('Upload a cover image')).click();
  }
  handleAllowOnlyAlpha = (e) => {
    const _char = String.fromCharCode(e.charCode);
    if (!/^[a-zA-Z0-9\s]$/.test(_char)) {
      e.preventDefault();
    }
  }
  onPasteFuncOnlyAlpha = (e) => {
    const text = e.clipboardData.getData('Text');
    const alphaNumericValue = text ? text.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚüÜ\s]/g, '') : '';
    if (text !== alphaNumericValue) {
      e.preventDefault();
    }
  }

  onChangeEventComment(e) {
    this.setState({
      txtEventComment: e.target.value  
    })

    const {setEventComment} = this.props;

    setEventComment(e.target.value);
    this.onValueUpdate("comment",e.target.value);
  }

  onChangeEventName() {
    const txtEventName = this.txtEventName.getValue();
    this.txtEventName.setValue(txtEventName.replace(/[^a-zA-Z0-9\s]/g, ''));
    const { setEventTxtValue, eventDateValue } = this.props;
    setEventTxtValue(txtEventName.replace(/[^a-zA-Z0-9\s]/g, ''));

    if(!this.props.isGiftListCreateEvent) {
    if(txtEventName && eventDateValue){
      this.setState({
        isDisabled: false,
      });
    } else {
      this.setState({
        isDisabled: true,
      });
    }
    }else{
      this.onValueUpdate("name",txtEventName.replace(/[^a-zA-Z0-9\s]/gi, ''));
    }

  }

  onChangeEventDate(date){
    const { setEventDateValue, eventTxtValue } = this.props;
    setEventDateValue(date);

    if(eventTxtValue && date){
      this.setState({
        isDisabled: false,
      });
    } else {
      this.setState({
        isDisabled: true,
      });
    }
  }

  onDeleteImage = () => {
    const { setSelectedImage1, setSelectedImage2 } = this.props;
    if(this.state.isImage1){
      setSelectedImage1("");
      this.onValueUpdate("image1","");
      this.setState({ showImageModal: false });
    } else {
      setSelectedImage2("");
      this.onValueUpdate("image2","");
      this.setState({ showImageModal: false });
    }
  }

  onSuccessUpdate = (isUpdated) => {
    this.setState({
      successUpdate: isUpdated 
    })
  }

  _getFormTitleByEventType = (eventName) => {
    const {lables} = this.props
       
    switch (eventName) {
      case 'Boda':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.bodaForm.label');
          
      case 'Cumpleaños':
        return  commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.birthdayForm.label');
          
      case 'Bebé':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.babyForm.label');
         
      case 'Bautizo':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.baptismForm.label');
      case 'Mascotas':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.mascatosForm.label');

      case 'Otros':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.otrasForm.label');
      case 'Otras Ceremonias Religiosas':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.otrasCeremoniasForm.label');

      case 'Open House':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.openHouseForm.label'); 
        
      case 'XV años':
        return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.xvAnosForm.label');

    }
    return commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.personalization.birthdayForm.label');
   }

  onClickNext = (validationCallBack) => {
    const { eventDetailsInfo, eventTxtValue } = this.props;

    const eventNameValidationRules = [
      { functionRef: commonUtil.isValueAvailable, funcData: [eventTxtValue], errorMessage: commonUtil.getError(errorObject.CreateEventStep2, 'CreateEventStep2.error.required') },
    ];

    const eventNameValid = commonUtil.validateTextInput(eventNameValidationRules, this.txtEventName, null);

    let eventName = '';

    if (eventNameValid) {
      eventName = eventTxtValue ? eventTxtValue : eventDetailsInfo.eventName;
    } else {
      eventName = '';
    }

    if (eventName) {

      const payload = {
        eventId : this.props.eventId,
        eventName: eventName ? eventName : eventDetailsInfo?.eventName || '',
        imageURL: this.props.selectedImage1 || '',
        eventTheme: this.props.selectedThemeUid ? this.props.selectedThemeUid : eventDetailsInfo?.eventTheme || '',
        eventBackground: this.props.selectedImage2 || '',
        comment: this.props.eventComment || '',
      }

      this.props.saveEventName(payload).then((response) => {
        if (response.body.statusMessage === constAPISuccess) {
          this.props.getEventDetails(this.props.eventId,this.props.profileId);

          if(channel === 'wap'){
            this.props.showMessagePopUp(true,true,true);
          }else{
            this.props.showMessagePopUp(true,true,true);
          }
          
          this.setState({
            isUpdated: false
          })
          
        }
        if (response.body.statusMessage === constAPIFailure) {
          this.warning.setMessage(response.body.errorMessage);
          this.onSuccessUpdate(false);
        }
      }).catch((e) => {
        this.onSuccessUpdate(false);
        console.log(e); // console required
      });
    }

    if (!eventNameValid) {
      document.getElementById('txtEventName').focus();
      commonUtil.goToTop();
    }
  }

  validate = (validationCallBack) => {
    const dateValue = this._CalenderSample && this._CalenderSample.state && this._CalenderSample.state.date ?
      this._CalenderSample.state.date : this._CalenderSample.props.value;
    const eventDateValidationRules = {
      functionRef: commonUtil.isValueAvailable, funcData: [dateValue], errorMessage: commonUtil.getError(errorObject.CreateEventStep2, 'CreateEventStep2.error.required'),
    };
    const eventNameValidationRules = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.txtEventName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep2, 'CreateEventStep2.error.required') },
    ];
    // const eventStateValidationRules = {
    //   functionRef: commonUtil.validateSelectedValue, funcData: [this.selectState.getSelectedIndex()], errorMessage: commonUtil.getError(errorObject.CreateEventStep2, 'CreateEventStep2.error.required'),
    // };
    // const eventStoreValidationRules = {
    //   functionRef: commonUtil.validateSelectedValue, funcData: [this.selectStore.getSelectedIndex()], errorMessage: commonUtil.getError(errorObject.CreateEventStep2, 'CreateEventStep2.error.required'),
    // };
    // let eventStoreValid = '';
    const eventDateValid = commonUtil.validateCalendarInput(eventDateValidationRules, this._CalenderSample, null);
    const eventNameValid = commonUtil.validateTextInput(eventNameValidationRules, this.txtEventName, null);
    // const eventStateValid = commonUtil.validateSelecteTab(eventStateValidationRules, this.selectState, null);
    if (eventDateValid) {
      this.formData.createEvent.eventDate = dateValue;
    }
    if (eventNameValid) {
      this.formData.createEvent.eventName = this.txtEventName.getValue();
    } else {
      this.formData.createEvent.eventName = '';
    }
    // if (eventStateValid) {
    //   eventStoreValid = commonUtil.validateSelecteTab(eventStoreValidationRules, this.selectStore, null);
    //   this.formData.createEvent.state = this.selectState.getValue();
    //   if (eventStoreValid) {
    //     this.formData.createEvent.store = this.selectStore.getValue();
    //   }
    // }
    if (this.uploadedImage) {
      this.formData.createEvent.imageURL = this.uploadedImage;
    }

    if(this.uploadedImage2) {
      this.formData.createEvent.imageURL2 = this.uploadedImage2;
    }

    const { eventName, state, store, eventDate } = this.formData.createEvent;
    if (eventName && eventDate) {
      validateEventName(this.props.user.result.emailId, eventName).then((response) => {
        if (response.body.status.status === constAPISuccess) {
          const { defineCreateEventData } = this.props; // eslint-disable-line no-shadow
          defineCreateEventData(this.currentIndex, { data: this.formData.createEvent });
          validationCallBack(true);
          return true;
        }
        const errorMessage = _.get(response, 'body.status.errorMessage', 'undefined error');
        createTag({
          event: 'alerta',
          phase: 'Crear mesa de regalos',
          step: 'Datos del evento',
          color: 'Rojo',
          mensaje: 'Datos incompletos evento',
          mensaje_servicio: errorMessage,
          seccion: 'Mesa de Regalos',
          tipo: 'pop-up',
        });
        this.warning?.setMessage(errorMessage);
        validationCallBack(false);
        return false;
      }).catch(err=>{
        const {lables} = this.props
        this.warning.setMessage(err.body?.detail);
        //this.warning?.setMessage(commonUtil.getLabel(lables.createEventStep2, "createEventStep2."+err?.body?.detail));
      })
    }

    createTagsForInvalidFormControls({
      controls: [this._CalenderSample, this.txtEventName, this.selectState, this.selectStore],
      tagCompositor: c => ({
        event: 'alerta',
        phase: 'Crear mesa de regalos',
        step: 'Datos del evento',
        color: 'Rojo',
        mensaje: 'Datos incompletos evento',
        mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
        seccion: 'Mesa de Regalos',
        tipo: 'formulario',
      }),
    });

    if (!eventDateValid) {
      document.getElementById('txtEventDate').focus();
      commonUtil.goToTop();
    } else if (!eventNameValid) {
      document.getElementById('txtEventName').focus();
      commonUtil.goToTop();
    } 
    // else if (!eventStateValid) {
    //   document.getElementById('selectState').focus();
    // } else if (!eventStoreValid) {
    //   document.getElementById('selectStore').focus();
    // }
  }

  render() {
    /* eslint-disable */
    const { lables, stateList, storeList, eventcategory, createEventObject, selectedTheme, eventDetailsInfo, eventStatus } = this.props;
    const isTemporaryClosed =  (eventStatus && ((eventStatus === constEventStatus.TEMPORARYCLOSED) || (eventStatus === constEventStatus.SUSPENDED) || (eventStatus === constEventStatus.CLOSED))) ? true : false;
    const isAnyUpdated = this.state.isUpdated || this.state.isCommentUpdated;
    /* eslint-enable */
    if (createEventObject && createEventObject.SelectTypeCelebration) {
      this.currentEvent = createEventObject.SelectTypeCelebration.selectedEventConfiguration.name;
      this.currentIndex = createEventObject.SelectTypeCelebration.selectedEventConfiguration.components[1].step;
      const prevIndex = createEventObject.SelectTypeCelebration.selectedEventConfiguration.components[0].step;
      if (createEventObject && createEventObject[prevIndex]) {
      const prevFormData = createEventObject[prevIndex].data;
       const coOwnerData = prevFormData.find(item => 
                                item?.coOwner && item?.coOwner?.includes("true") && (!item?.title || item.title.includes("Si"))
                              )
      const celebrityData = prevFormData.find(item => item?.celebrity && item?.celebrity?.includes("true"));
      this.ownerName = [prevFormData[0]?.firstName, prevFormData[0]?.lastName, prevFormData[0]?.maternalName].filter(Boolean).join(' ');
  
      this.coOwnerName = [coOwnerData?.firstName, coOwnerData?.lastName, coOwnerData?.motherName].filter(Boolean).join(' ');
  
      this.celebrityName = [celebrityData?.firstName, celebrityData?.lastName, celebrityData?.motherName].filter(Boolean).join(' ');
    }

    }
    if (createEventObject && createEventObject[this.currentIndex]) {
      const prepData = createEventObject[this.currentIndex].data;
      this.formData = {
        createEvent: {
          state: prepData.state,
          store: prepData.store,
          eventName: prepData.eventName,
          eventDate: prepData.eventDate,
          imageURL: prepData.imageURL,
          imageURL2: prepData.imageURL2,
          templateId: this.props.selectedThemeUid || '',
        },
      };
    }
    if (eventcategory && eventcategory.data) {
      const eventList = eventcategory.data.eventConfigurations;
      let event = '';
      if (eventList) {
        event = eventList.filter((even) => {
          if (even.name === this.currentEvent) {
            return even;
          }
          return null;
        });
      }
      if(this.props.isGiftListCreateEvent){
        this.calendar.minDays = parseInt(event[0]?.minDays || 0, 10);
        this.calendar.maxDays = parseInt(event[0]?.maxDays || 0, 10);
      } else {
        this.calendar.minDays = parseInt(event[0]?.minDays, 10);
        this.calendar.maxDays = parseInt(event[0]?.maxDays, 10);
      }
      
      
      this.eventIcon = event[0]?.event_icon;
    }
    const states = (stateList && stateList.stateListsInfo) ? stateList.stateListsInfo.states : [];
    let stores = [];
    if (storeList.storeListsInfo && storeList.storeListsInfo.stores) {
      stores = storeList.storeListsInfo.stores;
    }
    const textInputAttr = {
      textClassName: 'form-control',
      textPlaceholder: commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.eventdate.label'),
      textHtmlId: 'txtEventDate',
      textRequired: true,
    };
    /* eslint-disable */
    const StateOptions = [];
    states.forEach((e) => {
      for (const i in e) {
        const _StateOptions = {};
        _StateOptions.id = i;
        if ('DISTRITO FEDERAL' === e[i]){
          _StateOptions.value = 'DISTRITO FEDERAL';
          _StateOptions.labelResourceId = 'CDMX/Zona Metropolitana';
       } else {
        _StateOptions.value = e[i];
        _StateOptions.labelResourceId = e[i];
       }
        StateOptions.push(_StateOptions);
      }
    });
    const StoreOptions = [];
    if (stores.length) {
      stores.forEach((e) => {
        for (const i in e) {
          const _StoreOptions = {};
          _StoreOptions.id = i;
          _StoreOptions.value = e[i];
          _StoreOptions.labelResourceId = e[i];
          StoreOptions.push(_StoreOptions);
        }
      });
    } else {
      StoreOptions.push(commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.selectsttore.label'));
    }
    /* eslint-enable */
    const currentDate = new Date();
    const minimumDays = parseInt(this.calendar.minDays, 10);
    const maximumDays = parseInt(this.calendar.maxDays, 10);
    const minDate = new Date(
      currentDate.setDate(currentDate.getDate() + minimumDays),
    );
    const newCurrentDate = new Date();
    const maxDate = new Date(
      newCurrentDate.setDate(newCurrentDate.getDate() + maximumDays),
    );
    let monthDisplay = '';
    if (this.calendar && this.calendar.maxDays) {
      monthDisplay = Math.round(this.calendar.maxDays / 30);
    }
    return (
      <React.Fragment>
        <ApplyCSS pageName={pageName} />
        <div className="mainContainer" id="createEvent">
          {this.props.isGiftListCreateEvent &&
              <Warning2 style={{position: 'absolute',
              top: '171px',
              width: '92%',
              zIndex: 999,}} type={this.state.successUpdate ? "success" : "error"} text={this.warningMessage} ref={warning => this.warning = warning} />
          } 
          <div className={channel === 'web' ? 'container giftlist-container' : ''}>
            <div className="contentBox createEventContentBox">
              {!this.props.isGiftListCreateEvent &&
                <Warning style={channel === 'web' ? { width: '74%', left: '17px' } : {}} type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
              }
              <div className="row">
                <div className="col-xs-12 col-md-10 col-md-offset-1">
                  {!this.props.isGiftListCreateEvent && 
                  <div className="registerTitles">
                    {/* <h2 className="registerGiftTitle">{this.props.user.result.firstName}, {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.step2.title')}</h2> */}
                    {/* <p>{commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.step2.message.part1')} <b>{monthDisplay} meses</b> {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.step2.message.part2')}</p> */}
                    <p className="registerNewTitle">{commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.stepTwoSubHeading.label')}</p>
                    {/* <p className="requiredInput"><sup>*</sup> Campos obligatorios</p> */}
                  </div>}
                </div>
              </div>
              <div className="row">
                <div className={`col-xs-12 ${this.props.isGiftListCreateEvent ? 'col-md-12 event-container' : 'col-md-8 col-md-offset-2 column_equal_width createEventColumn'}`}>
                  <div className="row equal-height event-colums-wrapper">
                    <div className={`col-xs-12 col-md-6 ownerForm-container forms-container ${((this.props.isGiftListCreateEvent && (channel === 'web')) && 'pr-1')}`}>
                      <div className="padding_single_form_container">
                       <form className={channel === 'web' ? 'registerForm' : ''}>
                        <div className="row">
                          <div className="col-xs-12">
                            <div className="text-right labelStyle1">
                              {!this.props.isGiftListCreateEvent ? commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.camposObligatoros.label') : '*Campos obligatorios'}
                            </div>
                            <div className="event-color-title">
                              {this._getFormTitleByEventType(this.currentEvent)}
                            </div>
                            {!this.props.isGiftListCreateEvent &&
                            <div className="inputBlock">
                              <div className="input-group date" id="datetimepicker1">
                                <CalenderSample
                                  value={this.props.eventDateValue ? this.props.eventDateValue : this.formData.createEvent.eventDate}
                                  textInputJSON={textInputAttr}
                                  minDate={minDate}
                                  maxDate={maxDate}
                                  activeStartDate={minDate}
                                  onChangeHandler={date => this.onChangeEventDate(date)}
                                  ref={(CalenderData) => { this._CalenderSample = CalenderData; }}
                                // id="txtEventDate"
                                />
                              </div>
                            </div>}
                            {!this.props.isGiftListCreateEvent &&
                            <div className="infoBlock">
                              <div className="infoBlockIcon">
                                <img src={commonUtil.getAssetURL() + '/images/info.svg'} alt="Info Logo" />
                              </div>
                              <div className="infoBlockText">
                                {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.elligeNombre.label')}
                              </div>
                            </div>}
                            <div className="formBlock">
                              <TextInput
                                doNotUpdateOnPropsChange="true"
                                className="inputMaterial newInput"
                                labelClassName={channel === 'wap' ? 'placeHolderMaterial newLabel' : 'placeHolderMaterial'}
                                htmlId="txtEventName"
                                label={commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.eventname.label')}
                                required="true"
                                maxlength="100"
                                star="*"
                                value={this.props.isGiftListCreateEvent ? eventDetailsInfo.eventName : this.props.eventTxtValue ? this.props.eventTxtValue : this.formData.createEvent.eventName}
                                onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                                // onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                                onChange={this.onChangeEventName}
                                ref={txtEventName => this.txtEventName = txtEventName}
                                disabled= {isTemporaryClosed}
                              />
                            </div>
                            {this.props.isGiftListCreateEvent && <div className="section-break"></div>}
                            {!this.props.isGiftListCreateEvent ?
                            <div className="materialStyle">
                              <div className="imageBlock">
                                <div className="imageWrap">
                                  <img id="croppieImg" className={`${(this.props.selectedImage1 && this.state.image1Loading) ? "imageIconUpload" : "imageIconUpload imagePadding"} ${isTemporaryClosed ? 'cursor-disabled' : ''}`} src={this.props.selectedImage1 ? this.props.selectedImage1 : commonUtil.getAssetURL() + '/images/camera_alt.svg'} alt="Agregar Archivo" onClick={this.openProfileImageUploader} 
                                    onLoad={(e) => {
                                      if (e.target.src === this.props.selectedImage1) {
                                        this.setState({ image1Loading: true })
                                      }}}
                                    />
                                  {/* channel === 'wap' ? '' :
                        <label className="uploadIcon"><i className="iClass icon-camara" /></label> */}
                                </div>
                                <div className="actionUpload">
                                  <GCPCloudImageUploader ref={this.image1UploaderRef} imageType="image" eventId={this.props.eventId} onFileSuccess={this.onFileSuccess} fileAccept="image/*" textLabel={'Sube una imagen de tu evento'} onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} onFileAddedError={this.onFileAddedError} />
                                </div>
                              </div>
                            </div> : 
                            <div className="materialStyle wapImage-container">
                              <div className="image-label-container">
                                <div className="image-label-text">
                                  {commonUtil.getLabel(
                                    this.props.lables.EventAdminPage, 
                                    "adminpage.personalization.gift.profile.picture"
                                  )}
                                </div>
                                <div className="icon-wrapper" style={{ cursor: isTemporaryClosed ? 'not-allowed' : 'pointer' }}>
                                  <img name="Image 1" src={commonUtil.getAssetURL() + '/images/more_vert.svg'} alt="More vert" onClick={(e) => !isTemporaryClosed && this.toggleMenu(e)} />
                                </div>
                              </div>
                              <div className="imageBlock personalImageHeight">
                                <div className={`imageWrap imageWrap-for-overlay`}>
                                  <img id="croppieImg" className={`${(this.props.selectedImage1 && this.state.image1Loading) ? "imageIconUpload" : "imageIconUpload imagePadding"} ${isTemporaryClosed ? 'cursor-disabled' : ''}`} src={this.props.selectedImage1  ? this.props.selectedImage1 : commonUtil.getAssetURL() + '/images/camera_alt.svg'} alt="Agregar Archivo" onClick={!isTemporaryClosed && this.openProfileImageUploader} 
                                    onLoad={(e) => {
                                      if (e.target.src === this.props.selectedImage1) {
                                        this.setState({ image1Loading: true })
                                      }}}
                                    />
                                  {(this.props.selectedImage1) && 
                                  <div className="overlayDiv">
                                    <img style={{ cursor: isTemporaryClosed ? 'not-allowed' : 'pointer' }} className="overlayImage" src={commonUtil.getAssetURL() + '/images/camera_alt_white.svg'} alt="Camera White" />
                                  </div>}
                                </div>
                                <div className="actionUpload wapImage-actionUpload">
                                  <GCPCloudImageUploader ref={this.image1UploaderRef} imageType="image" eventId={this.props.eventId} onFileSuccess={this.onFileSuccess} fileAccept="image/*" onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} onFileAddedError={this.onFileAddedError} />
                                </div>
                              </div>
                            </div>
                            }
                            {this.props.isGiftListCreateEvent && <div className="section-break"></div>}
                            {!this.props.isGiftListCreateEvent ?
                            <div className="materialStyle">
                              <div className="imageBlock">
                                <div className="imageWrap">
                                  <img id="croppieImg2" className={`${(this.props.selectedImage2 && this.state.image2Loading) ? "imageIconUpload" : "imageIconUpload imagePadding"} ${isTemporaryClosed ? 'cursor-disabled' : ''}`} src={this.props.selectedImage2 ? this.props.selectedImage2 : commonUtil.getAssetURL() + '/images/camera_alt.svg'} alt="Agregar Archivo2" onClick={this.openProfileImageUploader2} 
                                    onLoad={(e) => {
                                      if (e.target.src === this.props.selectedImage2) {
                                        this.setState({ image2Loading: true })
                                      }}}
                                    />
                                </div>
                                <div className="actionUpload">
                                  <GCPCloudImageUploader ref={this.image2UploaderRef} imageType="cover"  eventId={this.props.eventId} onFileSuccess={this.onFileSuccess2} fileAccept="image/*" textLabel={'Sube una imagen de portada'} onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} onFileAddedError={this.onFileAddedError} />
                                </div>
                              </div>
                            </div> : 
                            <div className="materialStyle wapImage-container">
                              <div className="image-label-container">
                                <div className="image-label-text">
                                  {commonUtil.getLabel(
                                    this.props.lables.EventAdminPage, 
                                    "adminpage.personalization.gift.cover.image"
                                  )}
                                </div>
                                <div className="icon-wrapper" style={{cursor : isTemporaryClosed ? 'not-allowed' : 'pointer'}}>
                                  <img name="Image 2" src={commonUtil.getAssetURL() + '/images/more_vert.svg'} alt="More vert" onClick={(e) => !isTemporaryClosed && this.toggleMenu(e)} />
                                </div>
                              </div>
                              <div className="imageBlock personalImageHeight">
                                <div className={`imageWrap imageWrap-for-overlay`}>
                                  <img id="croppieImg2" className={`${(this.props.selectedImage2 && this.state.image2Loading) ? "imageIconUpload" : "imageIconUpload imagePadding"} ${isTemporaryClosed ? 'cursor-disabled' : ''}`} src={this.props.selectedImage2  ? this.props.selectedImage2 : commonUtil.getAssetURL() + '/images/camera_alt.svg'} alt="Agregar Archivo2" onClick={!isTemporaryClosed && this.openProfileImageUploader2} 
                                    onLoad={(e) => {
                                      if (e.target.src === this.props.selectedImage2) {
                                        this.setState({ image2Loading: true })
                                      }}}
                                    />
                                  {(this.props.selectedImage2) && 
                                  <div className="overlayDiv">
                                    <img style={{ cursor: isTemporaryClosed ? 'not-allowed' : 'pointer' }} className="overlayImage" src={commonUtil.getAssetURL() + '/images/camera_alt_white.svg'} alt="Camera White 2" />
                                  </div>}
                                </div>
                                <div className="actionUpload wapImage-actionUpload">
                                  <GCPCloudImageUploader ref={this.image2UploaderRef} imageType="cover" eventId={this.props.eventId} onFileSuccess={this.onFileSuccess2} fileAccept="image/*" textLabel={'Sube una imagen de portada'} onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} onFileAddedError={this.onFileAddedError} />
                                </div>
                              </div>
                            </div>}
                            {(this.props.isGiftListCreateEvent && this.state.showImageModal && channel === 'web' && eventStatus !== constEventStatus.TEMPORARYCLOSED) &&  
                              <ImageOptionsModal 
                               isWap={channel === 'wap'}
                               menuRef={(ref) => (this.menuRef = ref)} 
                               title={this.state.isImage1 ? 'Imagen de perfil' : 'Imagen de portada'}
                               closeImageOptionsModal={() => this.setState({ showImageModal: false })}
                               isImageAdded={this.state.isImage1 ? ((this.props.selectedImage1) ? true : false) : ((this.props.selectedImage2) ? true : false)}
                               openProfileImageUploader={this.state.isImage1 ? this.openProfileImageUploader : this.openProfileImageUploader2}
                               openCamera={this.openCamera}
                               deleteImage={this.onDeleteImage}
                              />
                            }

                            {(this.props.isGiftListCreateEvent && this.state.showImageModal && channel === 'wap' && eventStatus !== constEventStatus.TEMPORARYCLOSED) &&
                                <ImageOptionsModal
                                 isWap={channel === 'wap'}
                                 title={this.state.isImage1 ? 'Imagen de perfil' : 'Imagen de portada'}
                                 closeImageOptionsModal={() => this.setState({ showImageModal: false })}
                                 isImageAdded={this.state.isImage1 ? ((this.props.selectedImage1) ? true : false) : ((this.props.selectedImage2) ? true : false)}
                                 openProfileImageUploader={this.state.isImage1 ? this.openProfileImageUploader : this.openProfileImageUploader2}
                                 openCamera={this.openCamera}
                                 deleteImage={this.onDeleteImage}
                                />
                            }

                            {(this.props.isGiftListCreateEvent && this.state.showCameraModal && eventStatus !== constEventStatus.TEMPORARYCLOSED) &&
                                <CameraCaptureModal
                                 isWap={channel === 'wap'}
                                 title={this.state.isImage1 ? 'Imagen de perfil' : 'Imagen de portada'}
                                 onCapture={this.onCameraCapture}
                                 onClose={() => this.setState({ showCameraModal: false })}
                                />
                            }
                            
                            {this.props.isGiftListCreateEvent && <div className="section-break"></div>}
                            {this.props.isGiftListCreateEvent && 
                              <div class="event-color-title message-textarea-title">{commonUtil.getLabel(
                                this.props.lables.EventAdminPage, 
                                "adminpage.personalization.gift.comment.message"
                              )} 
                                <span class="message-textarea-title-span"> {commonUtil.getLabel(
                                    this.props.lables.EventAdminPage, 
                                    "adminpage.personalization.gift.comment.optional"
                                  )}</span>
                              </div>
                            }
                            {this.props.isGiftListCreateEvent && 
                              <div className="formBlock">
                                <FloatingLabelTextArea
                                  id={'txtEventComment'}
                                  label="Deja un mensaje para tus invitados"
                                  value={this.props.eventComment}
                                  placeholder={`(ej. ¡Estamos celebrando un momento\núnico y lleno de emoción! Gracias por\nser parte de él.)`}
                                  onChange={this.onChangeEventComment}
                                  maxLength={300}
                                  disabled={isTemporaryClosed}
                                />
                              </div>
                            }
                          </div>
                          {/* <div className="col-xs-12 col-sm-6 col-md-5">
                    <div className="tipBlock m-t-85">
                      <p><span>Tip:</span> {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.step2.tip')}</p>
                    </div>
                  </div> */}
                        </div>
                        {/* <div className="row selectStoreStep">
                  <div className="col-md-11 col-md-offset-1">
                    <p>{commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.selectpreferred.label')}</p>
                  </div>
                  <div className="col-xs-12 col-sm-5 col-md-offset-1">
                    <div className="formBlock">
                      <SelectionTab
                        classname="cSelect required"
                        field="state"
                        id="selectState"
                        options={StateOptions}
                        optionCaption={commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.selectstate.label')}
                        optionText={'labelResourceId'}
                        optionValue={'id'}
                        value={this.formData.createEvent.state}
                        sortOptions={true}   // eslint-disable-line react/jsx-boolean-value
                        handleSelectedOption={id => this.openStoreDropdown(id)}
                        disabled={StateOptions.length <= 0}
                        ref={selectState => this.selectState = selectState}
                      />
                    </div>
                    <div className="formBlock" style={{ display: 'none' }} id="storeList">
                      <SelectionTab
                        classname="cSelect required"
                        id="selectStore"
                        options={StoreOptions}
                        optionCaption={commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.selectsttore.label')}
                        optionText={'labelResourceId'}
                        optionValue={'id'}
                        value={this.formData.createEvent.store}
                        disabled={StoreOptions.length <= 0}
                        ref={selectStore => this.selectStore = selectStore}
                      />
                    </div>
                  </div>
                 </div> */}
                      </form>
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-6 ownerForm-container forms-container">
                          <div className="padding_single_form_container">
                          <ColorPicker selectedTheme={selectedTheme} lables={lables} eventStatus={eventStatus} disabled={isTemporaryClosed} />
                            <EventTemplate txtEventComment={this.state.isCommentUpdated ? this.state.txtEventComment : this.props.eventComment} icon={this.eventIcon} bgImage={this.eventPattern} selectedTheme={selectedTheme} ownerName={this.props.isGiftListCreateEvent ? this.props.ownerName : this.ownerName} coOwnerName={this.props.isGiftListCreateEvent ? this.props.coOwnerName : this.coOwnerName} celebrityName={this.props.isGiftListCreateEvent ? this.props.celebrityName : this.celebrityName} lables={lables} eventId={this.props.isGiftListCreateEvent ? this.props.eventId : ''} onActiveThemeColorUpdate={this.props.isGiftListCreateEvent ? this.props.onActiveThemeColorUpdate : ''} />
                          <ColorPickerOverlay onValueUpdate={this.props.isGiftListCreateEvent ? this.onValueUpdate : ''}/>
                          </div>
                    </div>
                </div>
                {
                    !this.props.isGiftListCreateEvent ?
                  <div className="row create-event-wizard stepTwoWapButtons" id="createEventPageEventWizard">
                    <EventWizard prev={this.props.eventWizardAttributes.prevAttr} next={this.props.eventWizardAttributes.nextAttr} submit={this.props.eventWizardAttributes.submitAttr} currentStep={this.props.currentStep} totalStep={this.props.totalStepsForEvent} isDisabled={this.state.isDisabled} />
                  </div> : 

                  <div className={`${(channel === "web") ? 'buttonBlock buttonBlock-gl giftlist-btn-update' : 'buttonBlock'} margin-top-70`} id="gift-list-contract-btn">
                    {channel === "wap" && 
                    <div className="col-xs-6 col-sm-6 col-lg-3 mb-60">
                      <div className="buttonBlock newButtonBlock">
                        <button 
                          className="btnSecondaryAction size-Large btnSecondaryAction size-Full" 
                          aria-hidden="false"
                          style={{
                            '--color-500': selectedTheme?.color_500 || '#333',
                            border: '1px solid var(--color-500)',
                            color: 'var(--color-500)',
                          }}
                          onClick={this.props.onBackClick}
                        >{commonUtil.getLabel(
                          this.props.lables.EventAdminPage, 
                          "adminpage.button.to.return1"
                        )}
                        </button>
                      </div>
                    </div>
                    }
                    
                    <div className={`col-xs-6 col-sm-6 mb-60 col-lg-3 ${(channel === "web") && 'float-right pr-0'}`}>
                      <div className="buttonBlock newButtonBlock">
                        <button 
                          disabled={!isAnyUpdated || isTemporaryClosed}
                          style={{
                            '--color-500': selectedTheme?.color_500 || '#333',
                          }}
                          onClick={this.onClickNext}
                          className={`btnPrimary size-Large size-Full ${(!isAnyUpdated || isTemporaryClosed) && 'disabledButton'}`} 
                          aria-hidden="false">{commonUtil.getLabel(
                            this.props.lables.EventAdminPage, 
                            "adminpage.personalization.gift.update.data"
                          )}
                        </button>
                      </div>
                    </div>

                  </div>
                  } 
              </div>
            </div>
          </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  const { themeData, selectedThemeUid } = state?.createEvent ?? {};
  let selectedTheme = null;

  if (themeData.length > 0) {
    selectedTheme = themeData.find((t) => t.uid === selectedThemeUid) || themeData[0];
  } 
  return {
    state,
    lables: state.labels.data,
    stateList: state.createEvent.dataState,
    storeList: state.createEvent.dataStore,
    eventTxtValue: state.createEvent.eventTxtValue,
    eventDateValue: state.createEvent.eventDateValue,
    selectedImage1: state.createEvent.selectedImage1,
    selectedImage2: state.createEvent.selectedImage2,
    eventComment: state.createEvent.eventComment, // only for edit scenario
    selectedThemeUid: selectedTheme?.uid,
    selectedTheme,
  };
};



const matchDispatchToProps = dispatch => bindActionCreators({ defineStoreListData, defineCreateEventData, setSelectedImage1, setSelectedImage2, setEventComment, setEventTxtValue, setEventDateValue, setThemeData, setSelectedThemeUid }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(CreateEvent);
